import type { FacilityPayload } from '@Application/Facilities/Facilities/Actions/facilitiesFetched';

export type FacilityUpdatedPayload = FacilityPayload;

export type FacilityUpdatedAction = {
	type: 'FACILITY_UPDATED';
	payload: FacilityUpdatedPayload;
	organizationId: number;
};

export default (payload: FacilityUpdatedPayload, organizationId: number): FacilityUpdatedAction => ({
	type: 'FACILITY_UPDATED',
	payload,
	organizationId,
});
